import moment from "moment"

export const determinarMora = (acceptDate, limitDays) => {

    let hoy = moment();
    let diffAcceptDaywithToday = hoy.diff(moment(acceptDate, "DD/MM/YYYY"), 'days');
    let hasMora = false;
    let diasMora = 0;

    if ((diffAcceptDaywithToday + 1) > limitDays) {
        diasMora = diffAcceptDaywithToday - limitDays;
        hasMora = true;
    }

    return {
        hasMora, diasMora
    }

}


export const determinarMora2 = (payDayLimit) => {

    let hoy = moment();
    let diffPaydayLimit = hoy.diff(moment(payDayLimit, 'DD/MM/YYYY'), 'days');

    let hasMora = false;
    let diasMora = 0;

    if ((diffPaydayLimit) > 0) {
        diasMora = diffPaydayLimit;
        hasMora = true;
    }
    
    return {
        hasMora, 
        diasMora
    }

}